import React from 'react';
import { Battery, Wifi, Signal } from 'lucide-react';
interface PhoneMockupProps {
  children: React.ReactNode;
}
export function PhoneMockup({
  children
}: PhoneMockupProps) {
  return <div className="relative mx-auto w-[375px] h-[812px] bg-white rounded-[50px] shadow-[0_0_0_12px_#0f172a,0_20px_40px_-10px_rgba(0,0,0,0.3)] overflow-hidden border-[6px] border-slate-800 flex flex-col" data-id="element-3">
      {/* Notch */}
      <div className="absolute top-0 inset-x-0 h-6 flex justify-center z-50" data-id="element-4">
        <div className="w-40 h-6 bg-slate-900 rounded-b-3xl" data-id="element-5"></div>
      </div>

      {/* Status Bar */}
      <div className="h-12 w-full px-6 flex items-center justify-between text-xs font-medium z-40 absolute top-0 inset-x-0 pointer-events-none" data-id="element-6">
        <span className="mt-1 text-slate-900 mix-blend-difference" data-id="element-7">9:41</span>
        <div className="flex items-center gap-1.5 mt-1 text-slate-900 mix-blend-difference" data-id="element-8">
          <Signal className="w-3.5 h-3.5" data-id="element-9" />
          <Wifi className="w-3.5 h-3.5" data-id="element-10" />
          <Battery className="w-4 h-4" data-id="element-11" />
        </div>
      </div>

      {/* Screen Content */}
      <div className="flex-1 overflow-y-auto custom-scrollbar bg-slate-50 relative pt-12" data-id="element-12">
        {children}
      </div>

      {/* Home Indicator */}
      <div className="absolute bottom-2 inset-x-0 flex justify-center z-50 pointer-events-none" data-id="element-13">
        <div className="w-32 h-1.5 bg-slate-900/20 rounded-full" data-id="element-14"></div>
      </div>
    </div>;
}